import { Component } from '@angular/core';
import {DialogService} from '@shared/services/dialog/dialog.service';
import {switchMap, take} from 'rxjs/operators';
import {EntitlementService} from '@shared/services/entitlement/entitlement.service';
import { ActivatedRoute } from '@angular/router';
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
    selector: 'app-non-entitled-user-landing-page',
    templateUrl: './non-entitled-user-landing-page.component.html',
    styleUrls: ['./non-entitled-user-landing-page.component.scss'],
    standalone: false
})
export class NonEntitledUserLandingPageComponent {
  public complimentaryLink = '/search/result/ALL?q=&page=1&filters=%7B"contentStatus":%5B"Complimentary"%5D%7D'
  public readonly currentYear = new Date().getFullYear();

  constructor(
    private dialogService: DialogService,
    private entitlementService: EntitlementService,
    private route: ActivatedRoute
  ) {}

  public openRequestModal() {
    this.route.queryParamMap.pipe(
      take(1),
      switchMap(pm => this.entitlementService.postAccessRequest(
        pm.get('url') ?? 'Contact form submitted from a non-entitled content page (403 error). ' +
        'User outreach is recommended.'
      )),
      untilDestroyed(this),
    ).subscribe({
      next: () => this.dialogService.openGeneric({
        actionButtonLabel: 'Done',
        body:
          'Our team has received your request for more information and will' +
          ' process your inquiry within 2 business days. ' +
          'We are looking forward to helping you!',
        title: 'Your request has been sent!',
        titleInformationLabel: 'Subscription Information Request',
      }),
      error: () => this.dialogService.openError(),
    });
  }
}
